import { Component, Input } from '@angular/core';

@Component({
  selector: 'apex-case-list-item-wrapper',
  templateUrl: './case-list-item-wrapper.component.html',
})
export class CaseListItemWrapperComponent {
  @Input() dense = false;
}
